import { FETCH_CATEGORIES_SUCCESS } from 'config/constants';

export default (state = [], action) => {
  const { type, categories } = action;
  switch (type) {
    case FETCH_CATEGORIES_SUCCESS:
      return categories;
    default:
      return state;
  }
};
